module.exports = __webpack_public_path__ + "img/10.85abea47.jpg";